import { render, staticRenderFns } from "./list-table-game-calculation.vue?vue&type=template&id=ac5d7cb6&scoped=true"
import script from "./list-table-game-calculation.vue?vue&type=script&lang=js"
export * from "./list-table-game-calculation.vue?vue&type=script&lang=js"
import style0 from "./list-table-game-calculation.vue?vue&type=style&index=0&id=ac5d7cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5d7cb6",
  null
  
)

export default component.exports